export default __webpack_public_path__ + "static/media/product.781cfa37.png";